import { render, staticRenderFns } from "./InfoDescription.vue?vue&type=template&id=125a74d8&"
import script from "./InfoDescription.vue?vue&type=script&lang=js&"
export * from "./InfoDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports